import { useUserRole } from '../../hooks/usePrerenderUser';
import { UserRole } from '../PrerenderUser';

// `SuperAdmin` is the account owner; every other role reached the account through
// an invitation. Which questions each survey then asks is `SHORT_SURVEY_CODES` in
// OnboardingSurvey.tsx (PRE-3134).
export const useAnswersShortSurvey = (): boolean => useUserRole() !== UserRole.SuperAdmin;
